import { render, staticRenderFns } from "./UploadProjectReport.vue?vue&type=template&id=db041a48&scoped=true&"
import script from "./UploadProjectReport.vue?vue&type=script&lang=ts&"
export * from "./UploadProjectReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db041a48",
  null
  
)

export default component.exports